export type AdminTheme = 'dark' | 'light';

const ADMIN_THEME_STORAGE_KEY = 'app_seller_admin_theme';

export function readAdminTheme(): AdminTheme {
  const storedTheme = localStorage.getItem(ADMIN_THEME_STORAGE_KEY);

  if (storedTheme === 'light') {
    return 'light';
  }

  return 'dark';
}

export function saveAdminTheme(theme: AdminTheme): void {
  localStorage.setItem(ADMIN_THEME_STORAGE_KEY, theme);
}
